// Vendor imports
const Immutable = require('immutable')
// Common Client V2 imports
const ArticleModelRecord = require('client-v2/common/models/article/record')
const CollectionModelRecord = require('client-v2/common/models/collection/record')

class TopCallToActionRecord extends Immutable.Record({
  article: new ArticleModelRecord(),
  collection: new CollectionModelRecord()
}) {
  static reviver(key, seq, keyPath) {
    if (key === '') {
      return new TopCallToActionRecord(seq)
    }
    if (key === 'article') {
      return new ArticleModelRecord(seq)
    }
    if (key === 'collection') {
      return new CollectionModelRecord(seq)
    }
    if (keyPath[0] === 'collection') {
      return CollectionModelRecord.reviver.call(this, key, seq, keyPath.slice(1))
    }
    return seq
  }
}

module.exports = TopCallToActionRecord
